let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3jfTc")).then(() => parcelRequire('1VIL4'));